import React, {Component} from 'react';
import axios from 'axios';
import config from "../config";
import withError from "../withError";
import i18n from "../i18n";
import LandingView from "../views/LandingView";

class LandingController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      introduction: '',
      buttonText: '',
      buttonAlt: '',
      credits: '',
      mediaLocation: '',
      mediaAlt: '',
      mediaThumbnail: '',
      mediaDuration: '',
      transcriptLink: '',
      transcriptText: '',
      transcriptLocation: ''
    };
  }

  componentDidMount() {
    axios.get(config.endpoints.landing, {
      headers: {
        'Accept-Language': i18n.language
      }
    })
    .then(response => {
      this.setState({
        title: response.data.landing.title,
        buttonText: response.data.landing.button.text,
        buttonAlt: response.data.landing.button.altText,
        introduction: response.data.landing.intro[0],
        credits: response.data.landing.credits,
        mediaLocation: response.data.landing.media.location,
        mediaAlt: response.data.landing.media.altText,
        mediaThumbnail: response.data.landing.media.thumbnail,
        mediaDuration: response.data.landing.media.duration,
        transcriptLink: response.data.landing.media.transcript.linkText,
        transcriptText: response.data.landing.media.transcript.text,
        transcriptLocation: response.data.landing.media.transcript.location
      });
    })
    .catch(error => {
      this.props.setError(error);
    });
  }

  render() {
    return <LandingView {...this.state}/>;
  }
}

export default withError(LandingController);
